import { render } from "./IconCheckBadge.vue?vue&type=template&id=062e831e"
const script = {}
script.render = render

export default script